import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=876aa388&scoped=true"
import script from "./projectList.vue?vue&type=script&lang=ts"
export * from "./projectList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876aa388",
  null
  
)

export default component.exports